import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectThirtyMinLayout } from '_redux/slices/timeline/timeline-control';
import { minuteWidth, minute30MinLayoutWidth } from '../../timeline-constants';
import { Colors } from '_styles';

const RedLine = (props) => {

    const [position, setPosition] = useState(0);
    const [currentTimeLabel, setCurrentTimeLabel] = useState('');
    const isThirtyMinLayout = useSelector(selectThirtyMinLayout);

    useEffect(() => {
        const updatePosition = () => {
            const now = new Date();
            const currentMinute = now.getMinutes();
            const hours = now.getHours().toString().padStart(2, '0');
            const minutes = currentMinute.toString().padStart(2, '0');

            // Calculate which 30-minute slot we're in
            const slotMinute = currentMinute < 30 ? 0 : 30;

            // Calculate minutes within the current 30-minute slot
            const minutesInSlot = currentMinute - slotMinute;

            // Convert to percentage (0-100% within the 30-minute slot)
            const percentage = (minutesInSlot / 30) * 100;

            setPosition(percentage);
            setCurrentTimeLabel(`${hours}:${minutes}`);
        };

        // Initial update
        updatePosition();

        // Update every minute to keep the line current
        const intervalId = setInterval(updatePosition, 60000);

        return () => clearInterval(intervalId);
    }, []);

    const lineWidth = isThirtyMinLayout ? minute30MinLayoutWidth : minuteWidth;

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: `${position}%`,
                width: `${lineWidth}px`,
                backgroundColor: 'red',
                zIndex: 255,
                pointerEvents: 'none', // Allow clicks to pass through
            }}
        >
            {/* time label + pointer above the red line (only on first column) */}
            {props.index == 0 && (
                <div
                    style={{
                        position: 'absolute',
                        top: '-22px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        pointerEvents: 'none',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '4px',
                            padding: '1px 6px',
                            fontSize: '14px',
                            lineHeight: 1.2,
                            color: 'red',
                            border: '2px solid red',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {currentTimeLabel}
                    </div>
                </div>
            )}
        </div>
    );
};

export default RedLine;
